import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as selectors from '../selectors';
import * as actions from '../actions';
import Edit from '../components/Edit';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';
import { getUserUrlPrefix } from '../../../../auth/selectors';
import confirmModal from '../../../../common/confirmModal';
import { t } from '../../../../../modules/infra/i18n';

const EditContainer = compose(
  withActiveUserIdAndType({ useShopForBarber: true }),
  withRouter,
  connect(
    (state, ownProps) => ({
      item: selectors.byId(state, ownProps.params.id),
      baseUrl: `${getUserUrlPrefix(state)}/customers/marketing-leads`,
      id: ownProps.params.id,
    }),
    {
      updateOwnerItem: actions.updateOwnerItem,
      deleteOwnerItem: actions.deleteOwnerItem,
      fetchOwnerItem: actions.fetchOwnerItem,
    },
  ),
  withHandlers({
    onSubmit: props => data => props.updateOwnerItem(props.activeId, props.activeType, props.params.id, data),
    onDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('customers:marketing_leads.delete_item_modal_title'),
        message: t('customers:marketing_leads.delete_item_modal_message'),
      });

      if (confirmed) {
        props.deleteOwnerItem(props.activeId, props.activeType, props.params.id).then(() => props.router.push(props.baseUrl));
      }
    },
    fetchData: props => () => props.fetchOwnerItem(props.activeId, props.activeType, props.params.id),
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.item) this.props.fetchData();
    },
  })
);

export default EditContainer(Edit);
